import { gql } from '@apollo/client';
import AddressFragment from "../../../fragments/Address";

const GET_COMPANY_INVOICECARD_KNOWN_COMPANIES = gql`
fragment knownFragment on KnownCompany
{
	companyId
	deliveryAddress{
		...AddressFields
	}
	invoiceAddress{
		...AddressFields
	}
	name
	orgNo
	publicCompanyId
	vatRegNo
}

query getKnownCompanies {
	companyAdminContext {
		salesDocuments {
			knownCompanies(companyId: 20) {
				knownCompanies{
					...knownFragment
				}
				publicCompanies{
					...knownFragment
				}
				supplierCompanies{
					...knownFragment
				}
			}
		}
	}
}
${AddressFragment}
`;
export default GET_COMPANY_INVOICECARD_KNOWN_COMPANIES;